import React, { useState } from 'react'
import $ from "jquery"
import suitcase from "./assets/img_suitcase.svg"
import ccard from "./assets/img_cc.svg"
import checklist from "./assets/img_checklist.svg"
import scan from "./assets/img_scan.svg"
import id from "./assets/img_id.svg"
import clearLogo from './assets/clear_white.svg'
import SwipeableViews from 'react-swipeable-views';
import GuideCompContainer from './guideCompContainer'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { setGoHome } from '../../action/homeAction';
import { CMSPath } from '../../../config/constant'
import { setShowCustomPopup } from '../../../action/action'

function CheckinStepsGuide(props) {

  const { t } = props
  const [skipSelfiePage, setSkipSelfiePage] = useState(true);
  const [requiredImages, setRequiredImages] = useState({
    verifyDetails: "checkInGuide_images/img_verifyDetails.png",
    verifyID: "checkInGuide_images/img_verifyID.png",
    clearID: "checkInGuide_images/img_verifyID.png",
    creditCard: "checkInGuide_images/img_card.png",
    bookingDetails: "checkInGuide_images/img_bookingDetails.png",
    companionDetails: "checkInGuide_images/img_companions.png"
  })

  const [isLastPage, setIsLastPage] = useState(false);
  const [currentPage, setCurrentPage] = useState(0)

  const handleChange = (index) => {
    console.log("index", currentPage, index)

    if(isLastPage && (currentPage < index)){
      handleChange(0);
      return;
    }
    
    let setPageChange = index;


    if(props.idVerificationDisabled){
      if(setPageChange == 1 && (currentPage < setPageChange)){
        setPageChange++;
      }
    }

    if(skipSelfiePage){
      if(setPageChange == 2 && (currentPage < setPageChange)){
        setPageChange++;
      }
    }

    if(!props.guestImagesCheckEnabled){
      if(setPageChange == 3 && (currentPage < setPageChange)){
        setPageChange++;
      }
    }

    if(!props.cardCheckEnabled){
      if(setPageChange == 4 && (currentPage < setPageChange)){
        setPageChange++;
      }
    }

    if(!props.cardCheckEnabled){
      if(setPageChange == 4 && (currentPage > setPageChange)){
        setPageChange--;
      }
    }

    if(!props.guestImagesCheckEnabled){
      if(setPageChange == 3 && (currentPage > setPageChange)){
        setPageChange--;
      }
    }

    if(skipSelfiePage){
      if(setPageChange == 2 && (currentPage > setPageChange)){
        setPageChange--;
      }
    }

    if(props.idVerificationDisabled){
      if(setPageChange == 1 && (currentPage > setPageChange)){
        setPageChange--;
      }
    }

    setCurrentPage(setPageChange);
  }

  React.useEffect(() => {

    $("body").addClass("overlay-cast");

    return () => {
        $("body").removeClass("overlay-cast");
    }
  }, [])

  React.useEffect(() => {
    if(props.accompanyGuestEnabled){
      if(currentPage == 6){
        setIsLastPage(true);
      } else {
        setIsLastPage(false);
      }
    } else {
      if(currentPage >= 5){
        setIsLastPage(true);
      } else {
        setIsLastPage(false);
      }
    }

  },[currentPage])

  const cancelCheckinProcess=()=>{
    props.setShowCustomPopup(true,{
      htmlTagId:"cancel-checkin-process",
      title:t("check_in.cancel_checkin_process.title"),
      subtitle:"",
      heading:t("check_in.cancel_checkin_process.heading"),
      subHeading:"",
      primaryButtonText:t("check_in.cancel_checkin_process.primaryButtonText"),
      secondaryButtonText:t("check_in.cancel_checkin_process.secondaryButtonText"),
      secondaryButtonStyleIsUnderline:true,
      primaryOnClick:()=>{props.setShowCustomPopup(false,{})},
      closeOnClick:()=>{props.setShowCustomPopup(false,{})},
      secondaryOnClick:()=>{ props.setGoHome(true); localStorage.removeItem("GDPR-Response"); props.setShowCustomPopup(false,{});}
  })   
}

const goBack=()=>{
  if(currentPage){
    handleChange(currentPage-1)
  } else if( props.allowUserLoginViaFindingReservation ) {
    props.backActionIfAllowUserLoginViaFindingReservationEnabled();
  } else{
    cancelCheckinProcess()
  }
}
  return (

    <div className='help-info'>
      <header class="inner-pages w-footer subpages">
        {
          process.env.REACT_APP_NEWER_DESIGN=="true" ?
          <a onClick={ goBack } className="button-back"></a>
          :
          <a onClick={() => { props.setGoHome(true); localStorage.removeItem("GDPR-Response") }} className="button-back"></a>
        }
        <div class="heading align-center">
          <div class="splash-brand">
            <img src={`${CMSPath}${props.logo}`} />
          </div>
        </div>

        {
          process.env.REACT_APP_NEWER_DESIGN=="true" &&
            <div class="cancel-check-in" onClick={cancelCheckinProcess}>
                          <div>Cancel </div>
                          <span style={{}}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                  <path d="M15 5L5 15M5 5L15 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                          </span>
            </div>
      }

      </header>

      <section class="widgets padding-0 margin-0 container-bg" style={{minHeight:"100vh"}} >

        <div class="widget-header widget-header-checkin-howto">
          <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckin_how_to_heading') : t('check_in.checkin_how_to_heading')}</div>
        </div>

        <div class="multi-tips gallery-alt">
          <div class="multi-tips-main">

            <div class="multi-tips-container">
              <SwipeableViews 
              index={currentPage}
              onChangeIndex={index => handleChange(index)}>

                {/* 0 - Check Booking */}
                <GuideCompContainer 
                  image={requiredImages.verifyDetails}
                  heading={process.env.REACT_APP_NEWER_DESIGN=="true"  ? (props.currentWidgetObj.widgetType == "Pre Check-in" ? t('check_in_steps_guide.booking_details.precheckin_heading') : t('check_in_steps_guide.booking_details.checkin_heading'))  :  t('check_in_steps_guide.booking_details.heading')}
                  text={t('check_in_steps_guide.booking_details.text')}
                  subText={props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.pre_checkIn_only_message') : t(`check_in.checkIn_only`)}
                />

                {/* 1 - ID Verification */}
								{props.clearFlowEnabled ? 
                <GuideCompContainer 
                  image={requiredImages.clearID}
                  heading={t('check_in_steps_guide.clear_id_verification.heading')}
                  text={t('check_in_steps_guide.clear_id_verification.text')}
                  subText={t('check_in_steps_guide.clear_id_verification.subtext')}
                />
                : !props.idVerificationDisabled
                ? <GuideCompContainer 
                  image={requiredImages.verifyID}
                  heading={t('check_in_steps_guide.id_verification.heading')}
									text={t('check_in_steps_guide.id_verification.text')}
                  subText={t('check_in_steps_guide.id_verification.subtext')}
                /> : <></>}

                {/* 2 */}
                {!skipSelfiePage ? <GuideCompContainer 
                  image={requiredImages.verifyID}
                  heading={t('check_in_steps_guide.selfie_check.heading')}
                  text={t('check_in_steps_guide.selfie_check.text')}
                  subText={t('check_in_steps_guide.selfie_check.subtext')}
                />: <></>}

                {/* 3 - Accompany Guest ID */}
                {props.guestImagesCheckEnabled ? <GuideCompContainer 
                  image={requiredImages.companionDetails}
                  heading={t('check_in_steps_guide.companion_id.heading')}
                  text={t('check_in_steps_guide.companion_id.text')}
                  subText={t('check_in_steps_guide.companion_id.subtext')}
                /> : <></>}

                {/* 4 - Credit Card */}
                {props.cardCheckEnabled ? <GuideCompContainer 
                  image={requiredImages.creditCard}
                  heading={t('check_in_steps_guide.card_verification.heading')}
                  text={t('check_in_steps_guide.card_verification.text')}
                  subText={t('check_in_steps_guide.card_verification.subtext')}
                /> : <></>}

                {/* 5 - Booking Details */}
                <GuideCompContainer 
                  image={requiredImages.bookingDetails}
                  heading={t('check_in_steps_guide.booking_details_form.heading')}
                  text={t('check_in_steps_guide.booking_details_form.text')}
                  subText={t('check_in_steps_guide.booking_details_form.subtext')}
                />

                {/* 6 - Accompany Guest Detials */}
                {props.accompanyGuestEnabled ? <GuideCompContainer 
                  image={requiredImages.companionDetails}
                  heading={t('check_in_steps_guide.companion_details.heading')}
                  text={t('check_in_steps_guide.companion_details.text')}
                  subText={t('check_in_steps_guide.companion_details.subtext')}
                />: <></>}

                </SwipeableViews>
						</div>

            <div class="multi-tips-pages">
              <span class={`pages ${currentPage == 0 && "current"}`}></span>
							{!props.idVerificationDisabled && <span class={`pages ${currentPage == 1 && "current"}`}></span>}
							{!skipSelfiePage && <span class={`pages ${currentPage == 2 && "current"}`}></span>}
							{props.guestImagesCheckEnabled && <span class={`pages ${currentPage == 3 && "current"}`}></span>}
							{props.cardCheckEnabled && <span class={`pages ${currentPage == 4 && "current"}`}></span>}
							<span class={`pages ${currentPage == 5 && "current"}`}></span>
              {props.accompanyGuestEnabled && <span class={`pages ${currentPage == 6 && "current"}`}></span>}
            </div>

            <div class="multi-tips-controls">
              {!isLastPage && <button class="button primary" onClick={() => handleChange(currentPage + 1)}>{t('check_in_steps_guide.next')}</button>}
              <button onClick={props.setStepsGuide} class="button">{isLastPage ? props.currentWidgetObj.widgetType == "Pre Check-in" ? t('check_in_steps_guide.pre_check_in') : t('check_in_steps_guide.check_in') : 'Skip intro'}</button>
            </div>

          </div>
        </div>
      </section>
    </div>
  )
}


const mapStateToProps = state => {
  return{
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    allowUserLoginViaFindingReservation: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.allowUserLoginViaFindingReservation

  }
}

export default connect(mapStateToProps,{setGoHome,setShowCustomPopup})(withTranslation('translations')(CheckinStepsGuide));